<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label="门店编号" name='store_sn'>
          <a-input v-model:value="search.store_sn" style="width:280px" placeholder="请输入关键词进行搜索" />
        </a-form-item>
        <a-form-item label="门店名称" name='store_name'>
          <a-input v-model:value="search.store_name" style="width:280px" placeholder="请输入关键词进行搜索" />
        </a-form-item>
        <a-form-item label="门店类型" name='store_type'>
          <a-select v-model:value="search.store_type" :style="{width:'200px'}" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option v-for='item in typeList' :key='item.type_id' :value="item.type_id">{{item.type_name}}
            </a-select-option>
          </a-select>
          <!-- <a-select class="m-l-20" v-model:value="search.store_level" :style="{width:'200px'}" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option v-for='item in levelList' :key='item.id' :value="item.id">{{item.level_name}}</a-select-option>
          </a-select> -->
        </a-form-item>

        <a-form-item label="门店级别" name='store_level'>
          <!-- <a-select v-model:value="search.store_type" :style="{width:'200px'}" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option v-for='item in typeList' :key='item.type_id' :value="item.type_id">{{item.type_name}}
            </a-select-option>
          </a-select> -->
          <a-select v-model:value="search.store_level" :style="{width:'200px'}" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option v-for='item in levelList' :key='item.id' :value="item.id">{{item.level_name}}</a-select-option>
          </a-select>
        </a-form-item>

           <a-form-item label="总部直属门店" name='is_brand'>
            <customizeSwitch v-model:value="search.is_brand" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit'>搜索</a-button>
        </a-form-item>
      </a-form>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='store_code' :columns='columns' :data-source='list'>
        <template v-slot:action="{ record }">
            <a v-has:onlinePriceStoreLook="()=>checkDetail(record,'detail')" href="javascript:;" class="m-r-10">查看</a>
            <a v-has:onlinePriceStoreEdit="()=>checkDetail(record,'edit')" href="javascript:;" v-if="record.is_brand">修改</a>
        </template>
      </a-table>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
    </a-card>
     <a-modal v-model:visible="storeDetailVisible" centered :width="700" :footer="null" destroyOnClose>
       <storeDetail :options="storeData" v-on:success="successEdit" />
     </a-modal>
  </a-layout>
</template>
<script>
import { ref, inject, reactive, toRefs, onMounted,h } from "vue";
import { getPublicTypeList, getPublicLevelList } from "@/api/store";
import {channelDiscountRateStore} from '@/api/online'
import { iscode } from "@/utils/app";
import store from "@/store";
import useTableSearch from "@/hooks/useTableSearch";
import storeDetail from "./detail.vue";
import { message } from 'ant-design-vue';
// 初始化默认筛选项数值
let defSearch = {
  page: 1,
  limit: 10,
  store_sn: "",
  store_name:'',
  store_level:'',
  store_type:'',
  is_brand:1
};
export default {
  components: {
    storeDetail
  },
  setup(props, ctx) {
    let columns = [
          {
          title: "门店编号",
          dataIndex: "store_code",
          key: "store_code",
        },
        {
          title: "门店名称",
          dataIndex: "store_name",
          key: "store_name",
        },
        {
          title: "门店地址",
          dataIndex: "address",
          key: "address",
        },
        {
          title: "所属上级",
          dataIndex: "dealer_name",
          key: "dealer_name",
        },
        {
          title: "门店级别",
          key: "level_name",
          dataIndex: "level_name",
          customRender:({record})=>{
              // return record.level_name || '-'
              return h('p',{
                style:{
                  'textAlign':'center'
                }
              },record.level_name||'-')
          }
        },
        {
          title: "门店类型",
          key: "type_name",
          dataIndex: "type_name",
          // customRender:({record})=>{
          //     return record.type_name+'/'+record.level_name
          // }
        },
        {
          title: "订货规则",
          dataIndex: "order_set_type_text",
          key: "order_set_type_text",
        },
        {
          title: "状态",
          dataIndex: "status_text",
          key: "status_text",
          width:100
        },
        {
          title: "操作",
          key: "action",
          width:120,
          fixed: 'right',
          slots: { customRender: "action" },
        },
    ];
    const state = reactive({
      typeList: [],
      levelList: [],
    });
    // 获取类型列表
    const getType = async () => {
      let res = await getPublicTypeList().then((res) => res.data);
      if (iscode(res)) {
        state.typeList = res.data.data;
      } else {
        message.error(res.msg);
      }
    };
    //获取等级列表
    const getLvevl = async () => {
      let res = await getPublicLevelList().then((res) => res.data);
      if (iscode(res)) {
        state.levelList = res.data.data;
      } else {
        message.error(res.msg);
      }
    };
    const {
      pageCurrentChange,
      pageSizeChange,
      search,
      list,
      initData,
      total,
      pageSearchChange,
      listLoading,
    } = useTableSearch({ data: defSearch });
    const tableHoosks = {
      pageCurrentChange,
      pageSizeChange,
      search,
      initData,
      list,
      total,
      pageSearchChange,
      listLoading,
    };
    onMounted(() => {
      tableHoosks.initData(channelDiscountRateStore, search.value);
      getType();
      getLvevl();
    });
    const form = ref();
    const storeData=ref({})
    const storeDetailVisible=ref(false)
    const checkDetail=(data,type)=>{
      storeDetailVisible.value=true
      storeData.value={}
      storeData.value=JSON.parse(JSON.stringify({
        ...data,
        type
      }))
    }
    const successEdit=()=>{
      storeDetailVisible.value=false
      tableHoosks.initData(channelDiscountRateStore, search.value);
    }
    return {
      info: store.state.user.info,
      ...toRefs(state),
      ...tableHoosks,
      columns,
      form,
      checkDetail,
      storeDetailVisible,
      storeData,
      successEdit
    };
  },
};
</script>